import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpEvent,
    HttpHandler,
    HttpErrorResponse,
} from '@angular/common/http';

@Injectable()
export class AuthExpiredHttpClientInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const authExpired =
                    error &&
                    error.status === 401 &&
                    error.message &&
                    error.url.indexOf('/api/account') === -1;
                if (authExpired) {
                    window.location.href = '';
                }
                return observableThrowError(error);
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/auth-expired.interceptor.ts